const initialState = () => ({
  showWarningOnExit: false,
  warningTab: '',
  actionView: '',
  showAction: false,
  contacts: [],
  selectedPlan: null,
  servicesOffering: {}
});

export default initialState;
